import { put } from 'redux-saga/effects';
import { error, info, success, warning } from 'react-notification-system-redux';
import i18n from 'i18next';

import { notificationsConfig } from '@config/constants';

import { extractGraphQlError } from './stringUtils';

export const putSuccess = (title: string, message: string) =>
  put(
    success({
      title: i18n.t(title),
      message: i18n.t(message),
      ...notificationsConfig.defaultConf,
    }),
  );

export const putError = (err: string, title: string, message: string) =>
  put(
    error({
      title: i18n.t(title),
      message: `${message ? i18n.t(message) + ': ' : ''}${extractGraphQlError(err)}`,
      ...notificationsConfig.defaultConf,
    }),
  );

export const putWarning = (title: string, message: string) =>
  put(
    warning({
      title: i18n.t(title),
      message: i18n.t(message),
      ...notificationsConfig.defaultConf,
    }),
  );

export const putInfo = (title: string, message: string) =>
  put(
    info({
      title: i18n.t(title),
      message: i18n.t(message),
      ...notificationsConfig.defaultConf,
    }),
  );
